import React from 'react';
import { Container } from 'react-bootstrap';
import SectionHeader from '../common/SectionHeader';
import aboutPhoto from '../../Assets/AboutMe/aboutPhoto.gif';

function AboutMe() {

  return (
    <Container fluid className="project-section">
      <div className="about-photo-container" style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <img
          src={aboutPhoto}
          alt="About me"
          className="about-photo"
          style={{
            maxWidth: '100%',
            width: 'min(500px, 90vw)',
            height: 'auto',
            borderRadius: '10px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
          }}
        />
      </div>
      <SectionHeader
        title={
          <>
            About <strong className="text-accent">Me </strong>
          </>
        }
        description="Hello! I am Nikoletta.
          A 3d animator and character designer.
          Through my character design I aim to make you feel that you belong.
          Each one of my characters carries a piece of shared experiences.
          Fragments of people you‘ve  randomly met, those you love, or those you admire, come together to form a familiar and unexpectedly humorous cast of characters who feel like old friends you’re meeting for the first time."
      />
    </Container>
  );
}

export default AboutMe;
